import React, { useState } from 'react'
import { Outlet, useLocation, useMatch, useNavigate, useOutletContext } from 'react-router-dom'
import { ButtonCreate } from '../../../components/styles/subheader-style'
import { Content } from './style'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'
import { Header } from '../../../components/SubHeaderFilter/types'
import { PageHeader } from '../../../components/StandardPage'

export const invoiceHeaders: Header[] = [
    { key: 'numeroNF', label: 'NF', type: 'string' },
    { key: 'orderId', label: 'Pedido', type: 'number' },
    { key: 'chaveAcesso', label: 'Chave de acesso', type: 'string' },
    { key: 'client', label: 'Destinatário', type: 'string' },
    { key: 'cfop', label: 'CFOP', type: 'string' },
    { key: 'valorTotalNota', label: 'Valor total', type: 'currency' },
    { key: 'createdAt', label: 'Emissão', type: 'date' },
    { key: 'status', label: 'Status', type: 'string', selectOptions: [
        { value: 'RASCUNHO', label: 'Rascunho' },
        { value: 'EMITINDO', label: 'Emitindo' },
        { value: 'EMITIDA', label: 'Emitida' },
        { value: 'NEGADA', label: 'Negada' },
        { value: 'CANCELADA', label: 'Cancelada' },
        { value: 'INUTILIZADA', label: 'Inutilizada' },
        { value: 'PENDENTE', label: 'Pendente' }
    ]}
]

export const taxScenarioHeaders: Header[] = [
    { key: 'nome', label: 'Nome', type: 'string' },
    { key: 'cnpjOrigem', label: 'CNPJ de origem', type: 'string' },
    { key: 'cfop', label: 'CFOP', type: 'string' },
    { key: 'aliquotaIPI', label: 'IPI%', type: 'number' }
]

interface TypeMainOutlet {
    search: string
}

const taxTabs = [
    { path: '/panel/invoice', name: 'Nota Fiscal' },
    { path: '/panel/invoice/tax-scenario', name: 'Cenário Fiscal' }
]

const TaxModuleLayout: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [refresh, setRefresh] = useState(false)
    const [handleChildSubmit, setHandleChildSubmit] = useState<(() => void) | null>(null);
    const { search } = useOutletContext<TypeMainOutlet>() || { search: '' }

    const isTaxScenario = !!useMatch('/panel/invoice/tax-scenario')
    const isCreatingScenario = !!useMatch('/panel/invoice/tax-scenario/create')
    const isCreatingInvoice = !!useMatch('/panel/invoice/create');
    const isEditingInvoice = !!useMatch('/panel/invoice/edit/:id');
    const isViewingInvoice = !!useMatch('/panel/invoice/view/:id');
    const isInvoiceDetail = isCreatingInvoice || isEditingInvoice || isViewingInvoice;

    const isInvoiceList = !isCreatingScenario && !isInvoiceDetail && !isTaxScenario

    const invoiceFiltersState = usePersistedFilters('tax_invoice')
    const scenarioFiltersState = usePersistedFilters('tax_scenario')

    const isScenarioList = isTaxScenario && !isCreatingScenario

    const activeTabKey = isInvoiceDetail || isCreatingScenario
        ? (isCreatingScenario ? '/panel/invoice/tax-scenario' : '/panel/invoice')
        : location.pathname

    return (
        <>
            <PageHeader
                title='Fiscal'
                tabs={taxTabs.map((tab) => ({ key: tab.path, label: tab.name }))}
                activeTab={activeTabKey}
                onTabChange={(key) => navigate(key)}
                onReload={!isCreatingScenario ? () => setRefresh((prev) => !prev) : undefined}
                filterHeaders={isInvoiceList ? invoiceHeaders : isScenarioList ? taxScenarioHeaders : undefined}
                appliedFilters={isInvoiceList ? invoiceFiltersState.appliedFilters : isScenarioList ? scenarioFiltersState.appliedFilters : undefined}
                onApplyFilter={isInvoiceList ? invoiceFiltersState.handleApplyFilter : isScenarioList ? scenarioFiltersState.handleApplyFilter : undefined}
                onRemoveFilter={isInvoiceList ? invoiceFiltersState.handleRemoveFilter : isScenarioList ? scenarioFiltersState.handleRemoveFilter : undefined}
                onClearAllFilters={isInvoiceList ? invoiceFiltersState.handleClearAll : isScenarioList ? scenarioFiltersState.handleClearAll : undefined}
                extraActions={isCreatingScenario ? (
                    <>
                        <ButtonCreate
                            onClick={() => navigate(-1)}
                            style={{ background: '#fff', color: '#0090D3', border: '1px solid #0090D3' }}
                        >
                            Cancelar
                        </ButtonCreate>
                        <ButtonCreate onClick={() => handleChildSubmit && handleChildSubmit()}>
                            Salvar Cenário
                        </ButtonCreate>
                    </>
                ) : undefined}
                createButton={!isCreatingScenario && isTaxScenario ? {
                    label: 'Novo Cenário',
                    onClick: () => navigate('/panel/invoice/tax-scenario/create'),
                } : isInvoiceList ? {
                    label: 'Nova Nota Fiscal',
                    onClick: () => navigate('/panel/invoice/create'),
                } : undefined}
            />

            <Content>
                <Outlet context={{ setHandleChildSubmit, refresh, search, appliedFilters: invoiceFiltersState.appliedFilters, scenarioFilters: scenarioFiltersState.appliedFilters }} />
            </Content>
        </>
    )
}

export default TaxModuleLayout
